export const DEG_MAX = { lat: 90, lon: 180 };

export const PRECISION_DEFAULTS = {
  DD_DECIMALS: 5,
  DM_DECIMALS: 5,
  DMS_DECIMALS: 5,
  HIGH_PRECISION: 5,
};

export const CONVERSION_CONSTANTS = {
  MINUTES_PER_DEGREE: 60,
  SECONDS_PER_DEGREE: 3600,
  SECONDS_PER_MINUTE: 60,
};

export const VALIDATION_LIMITS = {
  MAX_MINUTES: 60,
  MAX_SECONDS: 60,
};

export const ROLLOVER_THRESHOLDS = {
  MINUTES_TO_DEGREES: 60,
  SECONDS_TO_MINUTES: 60,
};

export const TEST_PRECISION = {
  FLOATING_POINT_TOLERANCE: 5,
};
